var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "sidebar-section detail-sidebar",
    attrs: {
      "id": ""
    }
  }, [_c('b-sidebar', {
    style: _vm.style,
    attrs: {
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": "",
      "no-header": "",
      "width": _vm.width || '60%'
    },
    on: {
      "hidden": function () {
        _vm.$emit('update:isShow', false);
        _vm.$emit('close');
      }
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('div', {
    staticClass: "sidebar-section__header d-flex"
  }, [_c('div', {
    staticClass: "sidebar-section__header--title w-50"
  }, [_c('h4', {
    staticClass: "mb-0 p-1 text-primary text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.title ? _vm.$t(_vm.title) : 'Detail') + " ")])]), _c('div', {
    staticClass: "sidebar-section__header--icon w-50 d-flex align-items-center justify-content-end"
  }, [_c('ez-icon', {
    staticClass: "cursor-pointer mx-50",
    attrs: {
      "icon": "ezAr-icon-x",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:isShow', false);
      }
    }
  })], 1)]), _vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }